import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import SpeakerPhoneIcon from '@material-ui/icons/SpeakerPhone';
import { formatActivityTime } from '../util/dateHelpers';

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    marginBottom: theme.spacing(3),
  },
  itemIcon: {
    padding: theme.spacing(1),
    borderRadius: '50%',
    width: '100%',
  },
  itemDetails: {
    marginLeft: theme.spacing(2),
  },
  detailsIcon: {
    color: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
  },
  blueIcon: {
    color: theme.palette.secondary.main,
    backgroundColor: '#EEF5FA',
  },
  redIcon: {
    color: '#EA534C',
    backgroundColor: '#FCEEED',
  },
  greenIcon: {
    color: '#6DC651',
    backgroundColor: '#F0F9EE',
  },
  itemDetailRow: {
    display: 'flex',
  },
}));

const ReportsCardholderActivityItem = (props) => {
  const { credential, name, timestamp, type } = props;
  const classes = useStyles();

  const selectItemIcon = () => {
    // TODO: find correct icons
    let icon = null;
    let wrapperClasses = null;
    if (name.includes('Access Granted')) {
      wrapperClasses = `${classes.itemIcon} ${classes.greenIcon}`;
      icon = (
        <img alt="granted card icon" src={`${window.location.origin}/images/green-door-open.png`} />
      );
    } else {
      wrapperClasses = `${classes.itemIcon} ${classes.redIcon}`;
      icon = (
        <img
          alt="denied card icon"
          src={`${window.location.origin}/images/red-door-closed-lock.png`}
        />
      );
    }
    return <div className={wrapperClasses}>{icon}</div>;
  };

  const formattedTime = `${formatActivityTime(timestamp, true)} (${formatActivityTime(
    timestamp,
    false
  )})`;

  return (
    <div className={classes.item}>
      <div>{selectItemIcon()}</div>
      <div className={classes.itemDetails}>
        <Typography variant="h6">{name}</Typography>
        <div className={classes.itemDetailRow}>
          <SpeakerPhoneIcon className={classes.detailsIcon} />
          <Typography>{credential}</Typography>
        </div>
        <div className={classes.itemDetailRow}>
          <WatchLaterIcon className={classes.detailsIcon} />
          <Typography>{formattedTime}</Typography>
        </div>
      </div>
    </div>
  );
};

export default ReportsCardholderActivityItem;
